import { Pipe, PipeTransform } from '@angular/core';
import { AppRoutes } from '../utils/enums/routes.enum';

@Pipe({
  name: 'ArianeTranslation',
  standalone: true,
})
export class ArianeTranslationPipe implements PipeTransform {
  transform(value: string, ...args: any[]): any {
    switch (value) {
      case AppRoutes.HOME:
        return $localize`:@@path_home:`;
      case 'product':
        return $localize`:@@path_product:`;
      case 'multifunction':
        return $localize`:@@path_multifunction:`;
      case AppRoutes.PATIENT:
        return $localize`:@@path_patient:`;
      case 'personalized-bag':
        return $localize`:@@path_personalized-bag:`;
      case 'pet-details':
        return $localize`:@@path_pet-details:`;
      case 'pet-owner':
        return $localize`:@@path_pet-owner:`;
      case 'pet-profile':
        return $localize`:@@path_pet-profile:`;
      case 'pet-record':
        return $localize`:@@path_pet-record:`;
      case 'place-order':
        return $localize`:@@path_place-order:`;
      case 'product-catalogue':
        return $localize`:@@path_product-catalogue:`;
      case 'products-recommendation':
        return $localize`:@@path_products-recommendation:`;
      case 'starter':
        return $localize`:@@path_starter:`;
      case 'starter-kit':
        return $localize`:@@path_starter-kit:`;
      case 'success-order':
        return $localize`:@@path_success-order:`;
      case AppRoutes.SUPPORT:
        return $localize`:@@path_support:`;
      case AppRoutes.WEIGHT_MANAGEMENT:
        return $localize`:@@path_weight-management:`;
      case AppRoutes.WEIGHT:
        return $localize`:@@path_weight:`;
      case AppRoutes.FOLLOW_UP:
        return $localize`:@@path_follow-up:`;
      case AppRoutes.ACCOUNT:
        return $localize`:@@path_account:`;
      case 'bcs':
        return $localize`:@@path_bcs:`;
      case AppRoutes.DAILY_ALLOWANCE:
        return $localize`:@@path_daily-allowance:`;
      case AppRoutes.RAPID_RECO:
        return $localize`:@@path_fast-reco:`;
      case AppRoutes.HEALTH:
        return $localize`:@@path_health:`;
      case AppRoutes.RENAL_DETECT:
        return $localize`:@@path_renal-detect:`;
      case AppRoutes.SHARE_RECOMMENDATION:
        return [$localize`:@@path_share-recommendation:`];
      case AppRoutes.NEW_PET:
        return $localize`:@@path_pet-profile:`;

      // PRODUCTS-PAGE: custom header links translations
      case '/products/prices':
        return [$localize`:@@word_prices:`];
      case '/products/catalogue':
        return [$localize`:@@path_product:`];
      case '/products/weight-loss':
        return [$localize`:@@path_pet-details:`, $localize`:@@path_product-catalogue:`];
      case '/products/starter-kit':
        return [$localize`:@@path_multifunction:`, $localize`:@@path_starter-kit:`];
      case '/pet-products/daily-allowance':
        return [$localize`:@@path_product-catalogue:`, $localize`:@@path_daily-allowance:`];
      case '/pet-products/personalized-bag':
        return [$localize`:@@path_product-catalogue:`, $localize`:@@path_personalized-bag:`];
      case '/pet-products/renal-detect':
        return [$localize`:@@path_renal-detect:`, $localize`:@@path_product-catalogue:`];
      case '/rapid-reco/products':
        return [$localize`:@@path_fast-reco:`];
      case '/rapid-reco/patient':
        return [$localize`:@@path_fast-reco:`, $localize`:@@path_patient:`];

      // Renal detect dailyAllowance
      case '/renal-detect/daily-allowance':
        return [$localize`:@@path_renal-detect:`, $localize`:@@path_product-catalogue:`, $localize`:@@path_daily-allowance:`];
      case '/renal-detect/recommendation':
        return [$localize`:@@path_renal-detect:`, $localize`:@@path_products-recommendation:`];

      /**
       * New Smart reco & allowance
       * Temporary until ariane data is in store
       */
      case '/smart-reco/patient':
        return [$localize`:@@home-page_product-finder-title:`, $localize`:@@path_patient:`];
      case '/smart-reco/recommendation':
        return [$localize`:@@path_products-recommendation:`];
      case '/allowance':
        return [$localize`:@@path_daily-allowance:`];
      case '/daily-allowance/patient':
        return [$localize`:@@path_daily-allowance:`, $localize`:@@path_patient:`];

      case '/weight-management/patient':
        return [$localize`:@@path_weight-management:`, $localize`:@@path_patient:`];
      case '/weight-management/recommendation':
        return [$localize`:@@path_weight-management:`, $localize`:@@path_product:`];
      case '/weight-management/plan-next-visit':
        return [$localize`:@@WLP_popin_title:`];

      default:
        return '--';
    }
  }
}
